import React, { useState, useContext } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import AssignmentIcon from "@material-ui/icons/Assignment"
import { green, red } from "@material-ui/core/colors"
import { Button, FormControl } from "@material-ui/core"
import { requestMegafile } from "../api/apiCalls"
import { UserContext } from "../contexts/UserContext"
import { HistoryContext } from "../contexts/HistoryContext"
import { MessagingContext } from "../contexts/MessagingContext"
import ConfirmationModal from "./modals/ConfirmationModal"

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 25,
  },
  card: {
    "& > *": {
      margin: theme.spacing(1),
    },
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  error: {
    color: red[500],
  },
  successMessage: {
    color: green[500],
    fontSize: "0.8em",
    marginTop: 10,
    maxWidth: 300,
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  button: {
    marginTop: 20,
    minWidth: 300,
    color: "white",
    maxWidth: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonDisabled: {
    color: "rgba(0,0,0,0.2)",
  },
  done: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonProgressValue: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -9,
    marginLeft: -7,
  },
  wrapper: {
    position: "relative",
  },
  lambdaButton: {
    minWidth: 300,
    color: "white",
    backgroundColor: "#DD5639",
    borderColor: "#DD5639",
    "&:hover": {
      backgroundColor: "#9F361F",
      borderColor: "#0062cc",
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#9F361F",
      borderColor: "#0062cc",
    },
    "&:focus": {
      boxShadow: "none",
      outline: "none !important",
    },
  },
}))

const RequestMegafileButton = ({ label }) => {
  const [transferring, setTransferring] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [error, setError] = useState()
  const classes = useStyles()
  const { user } = useContext(UserContext)
  const { fetchHistory } = useContext(HistoryContext)
  const { addErrorMessage, addSuccessMessage } = useContext(MessagingContext)

  const launchConfirmation = () => {
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
  }

  const callRequestMegafile = () => {
    setTransferring(true)
    // send queryString to woodstock
    requestMegafile(user)
      .then((data) => {
        if (data.statusCode === 200) {
          addSuccessMessage("Request", `for megafile generated.`)
          setTransferring(false)
          fetchHistory(user)
        } else {
          addErrorMessage("Error", `Unable to request megafile.`)
        }
      })
      .catch((error) => {
        setError(error)
        addErrorMessage("Error", `Unable to request megafile.`)
      })
  }

  return (
    <div className={classes.root}>
      <ConfirmationModal
        content={"Request Megafile?"}
        openModal={modalOpen}
        confirmFunction={callRequestMegafile}
        closeModalFunction={closeModal}
      />
      <FormControl className={classes.formControl}>
        <Button
          className={classes.lambdaButton}
          style={{ opacity: transferring ? "0.2" : "1.0" }}
          variant={transferring ? "outlined" : "contained"}
          color="secondary"
          disableElevation
          disabled={transferring}
          onClick={launchConfirmation}
          startIcon={<AssignmentIcon />}
        >
          {label}
        </Button>
        {error && <div className={classes.error}>{error}</div>}
      </FormControl>
    </div>
  )
}

RequestMegafileButton.propTypes = {
  label: PropTypes.string,
}

export default RequestMegafileButton
